import type { LucideIcon } from "lucide-react";
import { atLeast, type Role } from "../../schema/core.ts";
import type { SessionUser } from "../../schema/index.ts";

/** A header or account-menu link; `access` decides who sees it (a role: that role or higher). */
export interface SiteNavLink {
  to: string;
  /** Already localized. */
  label: string;
  icon?: LucideIcon;
  access: "public" | "user" | Exclude<Role, "learner">;
}

/** Links the visitor may see; while the session loads (null) only public ones. */
export const visibleLinks = (links: SiteNavLink[], user: SessionUser | null): SiteNavLink[] =>
  links.filter((link) => {
    if (link.access === "public") return true;
    if (user === null) return false;
    return link.access === "user" || atLeast(user.role, link.access);
  });
